import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { CourseService } from 'src/app/services/course.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-course-work-edit-enddate',
  templateUrl: './course-work-edit-enddate.component.html',
  styleUrls: ['./course-work-edit-enddate.component.scss']
})
export class CourseWorkEditEnddateComponent implements OnInit {

  @Input() loader: boolean;
  @Input() courseworks: any;
  @Input() courseId: string = '';
  @Output() onEndDateUpdate: EventEmitter<any> = new EventEmitter<any>()
  courseWorkId: string = '';
  scheduleId: string = '';
  isEditEndDateAllowed: boolean = false;

  isLoading: boolean = false;
  cwEndDateModalRef: any = null;
  @ViewChild('editCwEndDateModal', { static: false }) editCwEndDateModal!: ElementRef;
  cwEditEndDateForm!:FormGroup;
  submitEditEndDateForm: boolean = false;  
  todayDate: Date = new Date()
  minEndDate: any = null;
  oldEndDate: any = null;
  newEndDate: any = null;

  constructor(private modalService: NgbModal, private fb:FormBuilder, private ns: NotificationService, private courseService: CourseService, private commonService: CommonService) { }

  /**
   * To initialize component data
   */
  ngOnInit() {
    this.minEndDate = {year: this.todayDate.getFullYear(), month: this.todayDate.getMonth()+1, day: this.todayDate.getDate()}
    this.initCwEditEndDateForm()
  }

  /**
   * To detect input data changes.
   * @param {SimpleChanges} changes - To get input data
   */
  ngOnChanges(changes: SimpleChanges) {
    if ('loader' in changes && changes['loader'].firstChange == false) {
      if ('courseworks' in changes && changes['courseworks'].firstChange == false) {
        this.courseWorkId = this.courseworks._id;
        this.scheduleId = this.courseworks.schedule_id;
        this.isEditEndDateAllowed = this.courseworks.is_edit_enddate_allowed;
        this.cwEditEndDateForm.get('course_id').setValue(this.courseId);
        this.cwEditEndDateForm.get('coursework_id').setValue(this.courseWorkId);
        this.cwEditEndDateForm.get('coursework_instance_id').setValue(this.scheduleId);
        if(this.courseworks.new_end_date) {
          this.newEndDate = this.commonService.getFormatedDateByDateObject(this.courseworks.new_end_date);
        }
        else {
          this.oldEndDate = this.commonService.getFormatedDateByDateObject(this.courseworks.date, this.courseworks.course_work_timeline);
        }
      }      
    }
  }

  /**
   * To initialize course work edit end date form
   */
  initCwEditEndDateForm() {
    this.cwEditEndDateForm = this.fb.group({
      course_id: ['', Validators.required],
      coursework_id: ['', Validators.required],
      coursework_instance_id: ['', Validators.required],
      new_end_date: ['', [Validators.required]],
    });
  }

  /**
   * To open cw edit end date modal
   */
  openEditEndDateModal() {
    this.cwEndDateModalRef = this.modalService.open(this.editCwEndDateModal, { size: 'md', backdrop: 'static' });
  }

  /**
   * To close cw edit end date modal
   */
  closeCwEndDateModal() {
    this.submitEditEndDateForm = false;
    this.cwEditEndDateForm.get('new_end_date').reset();
    this.cwEndDateModalRef.close();
  }

  /**
   * To save new end date for coursework
   */
  onSaveEndDate() {
    this.submitEditEndDateForm = true;
    if(this.cwEditEndDateForm.invalid) {
      this.ns.showNotification('error', 'The form is not valid. Please provide all the required information.');
      return false;
    }
    const postData = {...this.cwEditEndDateForm.value};
    this.isLoading = true;
    this.courseService.editCourseworkEndDate(postData).subscribe((response: any) => {
      this.isLoading = false;
      this.closeCwEndDateModal();
      this.ns.showNotification('success',  response.message);
      this.onEndDateUpdate.emit({ status: true });
    },(error: any) => {
      this.isLoading = false;
      this.submitEditEndDateForm = false;
      this.ns.showNotification('error', error.message);
    });
  }
}
